import { Button, Col, Container, Image, Row } from 'react-bootstrap';

import HalfLogo from 'assets/img/landing/halfGrayLogo.svg';
import BeatMonoLogo from 'assets/img/landing/monoLogo.svg';
import FiveImage from 'assets/img/landing/5X.svg';
import PersonOne from 'assets/img/landing/personWithStar.svg';
import PersonTwo from 'assets/img/landing/personWithSuitcase.svg';
import { PageContentInfo, Props } from './bookDemo.type';
import { LandingRole } from 'pages/landing/main.type';
import BookDemoModal from 'components/modals/BookDemoModal';
import { useState } from 'react';

const pageDetailsMapping: Record<LandingRole, PageContentInfo> = {
  default: {
    title: 'Why Choose CRUD Beat?',
    description:
      'Experience the power of a partner who’s invested in your success, from skill-building to placement',
    logoCard: { title: 'Where Innovation Meets Hiring Success!' },
    xCard: {
      title: 'Innovative Technology',
      value: 'Advanced tools tailored for hiring and training success',
      isHideImge: true
    },
    StudCard: {
      value: 'Proven Results',
      title: 'Trusted by institutions and organizations worldwide.'
    },
    businessCard: {
      value: 'Comprehensive Support',
      title: 'From preparation to placement, we’ve got you covered'
    }
  },
  student: {
    title: 'Why CRUD Beat Stands Out The Edge You Need in Talent & Training',
    description:
      'Experience the power of a partner who’s invested in your success, from skill-building to placement',
    logoCard: { title: 'Tech Portfolios Created', value: '10,000+ ' },
    xCard: { title: 'Hackathons & Competitions Hosted' },
    StudCard: { title: 'Certifications Awarded', value: '25,000+' },
    businessCard: { title: 'Hiring Companies Onboard', value: '1,000+' }
  },
  recruiter: {
    title: 'Why CRUD Beat Stands Out The Edge You Need in Talent & Training',
    description:
      'Experience the power of a partner who’s invested in your success, from skill-building to placement',
    logoCard: { title: 'Tech Portfolios Created', value: '10,000+ ' },
    xCard: { title: 'Hackathons & Competitions Hosted' },
    StudCard: { title: 'Certifications Awarded', value: '25,000+' },
    businessCard: { title: 'Hiring Companies Onboard', value: '1,000+' }
  },
  college: {
    title: 'Why CRUD Beat Stands Out The Edge You Need in Talent & Training',
    description:
      'Experience the power of a partner who’s invested in your success, from skill-building to placement',
    logoCard: { title: 'Tech Portfolios Created', value: '10,000+ ' },
    xCard: { title: 'Hackathons & Competitions Hosted' },
    StudCard: { title: 'Certifications Awarded', value: '25,000+' },
    businessCard: { title: 'Hiring Companies Onboard', value: '1,000+' }
  }
};

function BookDemo({ role }: Props) {
  const [show, setShow] = useState(false);
  const pageDetails = pageDetailsMapping[role];

  return (
    <Container fluid className="bg-body-highlight demo pt-14">
      <BookDemoModal show={show} onClose={() => setShow(false)} />
      <Row className={`demo_cover-${role}`}>
        <Col
          lg={6}
          className="px-lg-10 py-lg-14 px-md-10 py-md-14 px-sm-10 py-sm-14 px-4 py-0 d-flex flex-column justify-content-center align-items-start demo_cover_left"
        >
          <p className="fs-3 fw-bold lh-sm demo_cover_left_heading">
            {pageDetails.title}
          </p>
          <p className="fs-8 pt-3 demo_cover_left_desc">
            {pageDetails.description}
          </p>
          <Button
            variant="primary"
            className="mt-3 px-6 py-3 rounded-4"
            onClick={() => setShow(true)}
          >
            Book Demo
          </Button>
        </Col>
        <Col
          lg={6}
          className="p-lg-10 p-md-10 p-sm-10 px-4 py-10 d-flex justify-content-center align-items-center demo_cover_right"
        >
          <Row className="demo_cover_right_wrapper">
            <Col
              lg={6}
              className="d-flex justify-content-center"
              style={{ minHeight: '230px' }}
            >
              <div className="position-relative bg-white rounded-4 p-3 d-flex flex-column justify-content-between align-items-center w-90 h-90 rotate">
                <Image
                  src={HalfLogo}
                  alt="HalfLogo"
                  width={150}
                  className="position-absolute top-0 start-10"
                />
                <Image
                  src={BeatMonoLogo}
                  alt="BeatMonoLogo"
                  width={70}
                  height={70}
                  className="mt-5"
                />
                {pageDetails.logoCard && (
                  <div className="mt-4 w-100">
                    <p className="m-0 fw-bold fs-7">
                      {pageDetails.logoCard.value}
                    </p>
                    <p className="m-0 fw-semibold">
                      {pageDetails.logoCard.title}
                    </p>
                  </div>
                )}
              </div>
            </Col>
            <Col
              lg={6}
              className="d-flex justify-content-center"
              style={{ minHeight: '230px' }}
            >
              <div className="w-90 h-90 p-3 rounded-4 demo_cover_right_wrapper_blurCard d-flex flex-column justify-content-between">
                <Image
                  src={FiveImage}
                  alt="FiveImage"
                  className={`pt-4 ${
                    pageDetails.xCard.isHideImge ? 'd-none' : 'd-block'
                  }`}
                  height={80}
                  style={{ width: 'fit-content' }}
                />
                <div></div>
                <div>
                  <p className="pt-3 m-0 fw-bold text-black">
                    {pageDetails.xCard.title}
                  </p>
                  <p className="m-0 mt-2 text-black">
                    {pageDetails.xCard.value}
                  </p>
                </div>
              </div>
            </Col>
            <Col
              lg={6}
              className="d-flex justify-content-center"
              style={{ minHeight: '230px' }}
            >
              <div className="w-90 h-90 p-3 bg-white rounded-4 position-relative d-flex flex-column justify-content-between">
                <Image
                  src={PersonOne}
                  alt="personOne"
                  className="position-absolute top-20 end-20"
                  width={50}
                />
                <div></div>
                <div>
                  <p className="fs-7 fw-bold text-black">
                    {pageDetails.StudCard.value}
                  </p>
                  <p className="text-black m-0 fs-8">
                    {pageDetails.StudCard.title}
                  </p>
                </div>
              </div>
            </Col>
            <Col
              lg={6}
              className="d-flex justify-content-center"
              style={{ minHeight: '230px' }}
            >
              <div className="w-90 h-90 p-3 bg-white rounded-4 position-relative d-flex flex-column justify-content-between">
                <Image
                  src={PersonTwo}
                  alt="personPersonTwo"
                  className="position-absolute top-20 end-20"
                  width={50}
                />
                <div></div>
                <div>
                  <p className="fs-7 fw-bold text-black">
                    {pageDetails.businessCard.value}
                  </p>
                  <p className="text-black fs-8 m-0">
                    {pageDetails.businessCard.title}
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}

export default BookDemo;
